import type { RouteObject } from 'react-router-dom'
import { Navigate, useParams } from 'react-router-dom'
import { SpendHomePage } from './SpendHome'
import { BatchPage } from './BatchPage'
import { fileLink } from './common'

// Old links (emails already sent) keep working.
function OldFileLink() {
  const { id } = useParams()
  return <Navigate replace to={fileLink(id!)} />
}

export const routes: RouteObject[] = [
  { path: '/partner/spend', element: <SpendHomePage /> },
  { path: '/partner/spend/email', element: <SpendHomePage pick="email" /> },
  { path: '/partner/spend/stripe', element: <SpendHomePage pick="stripe" /> },
  { path: '/partner/spend/upload', element: <SpendHomePage pick="upload" /> },
  { path: '/partner/spend/files/:id', element: <BatchPage /> },
  { path: '/partner/spend/batches/:id', element: <OldFileLink /> },
  { path: '/partner/spend/health', element: <Navigate replace to="/partner/spend" /> },
]
